// dependencies
import React from "react";
import { Link } from "react-router-dom";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//components
import Typography from "../Text";
// styles
import css from "./Tabs.module.scss";

interface Title {
	id: string;
	label: string;
	size?: number;
	href?: string;
	icon?: IconProp;
	iconStyle?: React.CSSProperties;
}

interface BaseProps {
	className?: string;
	activeTitle: string;
	titles: Title[];
	onSelectTitle: (titleID: string) => void;
	filled?: boolean;
	fixedTabWidth?: number;
}

/**
 * @deprecated Use the Tabs component from the py-components package instead
 * Tabs component for page navigation
 */
const Tabs = (props: BaseProps) => {
	const { className, activeTitle, titles, onSelectTitle, filled = false, fixedTabWidth } = props;

	return (
		<div className={`${css.tabTitles} ${filled ? css.filled : null} ${className ? className : ""}`}>
			{titles.map((title) => {
				const content = (
					<>
						{title.icon && (
							<div className={css.tabIcon}>
								<FontAwesomeIcon
									icon={title.icon}
									className={css.tabIcon}
									style={title.iconStyle}
									data-testid={`${title.label}-icon`}
								/>
							</div>
						)}
						<Typography size="paragraph-3" weight="regular">
							{`${title.label}`} {title.size ? `(${title.size})` : ""}
						</Typography>

						{filled ? null : <div className={css.tabUnderline} />}
					</>
				);

				if (title.href) {
					return (
						<Link
							key={title.id}
							to={title.href}
							className={`${css.navItem} ${activeTitle === title.id ? css.isActive : ""}`}
						>
							{content}
						</Link>
					);
				}

				return (
					<div
						key={title.id}
						style={{ width: fixedTabWidth ? `${fixedTabWidth}px` : "auto" }}
						className={`${css.navItem} ${activeTitle === title.id ? css.isActive : ""}`}
						onClick={() => onSelectTitle(title.id)}
					>
						{content}
					</div>
				);
			})}
		</div>
	);
};

export default Tabs;
